// DEMO watermark painted BEHIND the document text.
//
// Owner, TestFlight device test 2026-09-12: 「水印要在字体的后面。不是单独空白。这样很容易给人截图2次
// 创作。」 The watermark used to be a block of its own between two sections, so a screenshot of the
// text could simply leave it out. It is now a tiled image on the document root's background: under
// every line, repeated down the whole length of the document, in the app and in the PDF alike.
//
// An image, never text nodes: the PDF is paginated by jsPDF's autoPaging 'text' (src/report/pdf.ts),
// which walks the text nodes to choose page breaks — watermark words spread over the page would
// become break candidates of their own.
const TILE_WIDTH = 420;
const TILE_HEIGHT = 260;

function escapeXml(text: string): string {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
}

// One tile: a mark at the centre and one on each corner, so neighbouring tiles complete the corner
// marks into a staggered pattern with no clean band between two rows.
export function demoWatermarkSvg(text: string): string {
  const label = escapeXml(text);
  const mark = (x: number, y: number) =>
    `<text x="${x}" y="${y}" transform="rotate(-24 ${x} ${y})" text-anchor="middle" dominant-baseline="central" font-family="Inter, PingFang SC, Hiragino Sans GB, Microsoft YaHei, sans-serif" font-size="46" font-weight="800" letter-spacing="3" fill="#ba1a1a" fill-opacity="0.13">${label}</text>`;
  const points: Array<[number, number]> = [
    [TILE_WIDTH / 2, TILE_HEIGHT / 2],
    [0, 0],
    [TILE_WIDTH, 0],
    [0, TILE_HEIGHT],
    [TILE_WIDTH, TILE_HEIGHT]
  ];
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${TILE_WIDTH}" height="${TILE_HEIGHT}" viewBox="0 0 ${TILE_WIDTH} ${TILE_HEIGHT}">${points.map(([x, y]) => mark(x, y)).join('')}</svg>`;
}

// The inline style for the document root. Every character that could end the url('…') token or the
// double-quoted attribute it sits in is percent-encoded.
export function demoWatermarkStyle(text: string): string {
  const encoded = encodeURIComponent(demoWatermarkSvg(text)).replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29');
  return `background-image:url('data:image/svg+xml;charset=utf-8,${encoded}');background-repeat:repeat;background-size:${TILE_WIDTH}px ${TILE_HEIGHT}px`;
}
